import styled from "styled-components";
import Color from "color";

export const Container = styled.div`
  display: flex;
  height: 8.7rem;
  margin-bottom: 2.2rem;
  margin-right: 1.4rem;
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.6rem;
  line-height: 2.2rem;
  font-weight: 600;
  color: #181c24;
  text-align: right;

  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `}
`;

export const LabelColor = styled.div`
  width: 1.4rem;
  height: 1.4rem;
  flex-shrink: 0;
  margin-right: 0.8rem;
  border-radius: 0.3rem;
  background-color: ${({ theme, secondary }) =>
    secondary
      ? Color(theme.live.colors.primary).alpha(0.5)
      : theme.live.colors.primary};
`;

export const Labels = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 1.5rem;

  ${Label}:not(:first-child) {
    margin-top: 1.8rem;
  }

  ${({ theme }) => theme.media.md`
    display: none;
  `}
`;

export const MobileLabels = styled.div`
  display: none;
  margin-top: 4.8rem;
  justify-content: center;

  ${Label} {
    text-align: left;
  }

  ${Label}:not(:first-child) {
    margin-top: 0.4rem;
  }

  ${({ theme }) => theme.media.md`
    display: flex;
  `}
`;

export const BarsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  position: relative;
  z-index: 1;
`;

export const Bar = styled.code`
  display: block;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 2rem;
  color: #fff;
  height: 2rem;
  padding: 0 0.6rem;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  background-color: ${({ theme, secondary }) =>
    secondary
      ? Color(theme.live.colors.primary).alpha(0.5)
      : theme.live.colors.primary};
  text-align: right;

  ${({ theme }) => theme.media.sm`
    font-size: 1.3rem;
    line-height: 2rem;
  `}
`;

export const Bars = styled.div`
  display: flex;
  justify-items: center;
  flex-direction: column;
  width: 100%;
  position: relative;
  z-index: 1;

  ${Bar}:not(:first-child) {
    margin-top: 2.1rem;
  }
`;

export const ChartLines = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ChartLine = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
  width: calc(100% / 6);
  border-right: 0.1rem dashed rgba(0, 0, 0, 0.18);
  height: 100%;

  &:first-child {
    border-left: 0.1rem dashed rgba(0, 0, 0, 0.18);
  }
`;

export const ChartLineLabel = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 2.2rem;
  color: #181c24;
  transform: translate(-50%, 100%);
  margin-bottom: -0.5rem;

  &:first-child {
    transform: translate(-50%, 100%);
  }

  &:last-child {
    transform: translate(50%, 100%);
  }

  ${({ theme }) => theme.media.sm`
    font-size: 1.3rem;
    line-height: 2rem;
  `}
`;
